import React from 'react';

import { Box, Typography } from '@mui/material';

import {
  BRIGHT_HONEY_DEW,
  BRIGHT_HONEY_DEW_HOVER,
  FONT_FAMILY,
  MID_TEAL,
  PRIMARY_GREEN
} from './colors';

interface SignUpCardProps {
  signUpUrl: string;
}

const SignUpCard = ({ signUpUrl }: SignUpCardProps) => (
  <Box
    sx={{
      backgroundColor: MID_TEAL,
      borderRadius: '20px',
      padding: '32px',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    }}
  >
    <Typography
      sx={{ fontFamily: FONT_FAMILY, fontWeight: 800, fontSize: '20px', color: PRIMARY_GREEN }}
    >
      Sign up for our job alert
    </Typography>
    <Typography
      sx={{ fontFamily: FONT_FAMILY, fontSize: '14px', color: PRIMARY_GREEN, opacity: 0.8 }}
    >
      Sign up here to be notified about new job opportunities relevant to you!
    </Typography>
    <Box
      component="a"
      href={signUpUrl}
      sx={{
        alignSelf: 'flex-start',
        border: 'none',
        cursor: 'pointer',
        textDecoration: 'none',
        backgroundColor: BRIGHT_HONEY_DEW,
        color: PRIMARY_GREEN,
        fontFamily: FONT_FAMILY,
        fontWeight: 600,
        fontSize: '16px',
        borderRadius: '104px',
        padding: '16px 24px',
        transition: '0.3s',
        '&:hover, &:focus': { backgroundColor: BRIGHT_HONEY_DEW_HOVER }
      }}
    >
      Sign up
    </Box>
  </Box>
);

export default SignUpCard;
